import { motion } from "framer-motion";
import { joinReal } from "@/lib/display";

export function ProjectCard({ project, index = 0, large = false }) {
  const meta = joinReal([project.location, project.year]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`project-card-${project.slug}`}
      className={`group relative block overflow-hidden bg-navy ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}
    >
      <img
        src={project.cover}
        alt={project.title}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/30 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-500" />
      <div className="absolute inset-0 grid-lines-dark opacity-0 group-hover:opacity-20 transition-opacity duration-500" />

      <div className="absolute top-5 left-5">
        <span className="inline-block text-[11px] tracking-[0.2em] uppercase text-cyan bg-navy/50 backdrop-blur-sm px-3 py-1.5 border border-cyan/30">
          {project.category}
        </span>
      </div>

      <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
        <h3 className="font-head font-bold text-white text-xl md:text-2xl tracking-tight leading-tight">
          {project.title}
        </h3>
        {meta && <p className="text-silver/70 text-sm mt-1">{meta}</p>}
      </div>
    </motion.div>
  );
}
